import { render, staticRenderFns } from "./About_Location_Item.vue?vue&type=template&id=02fc3c93&scoped=true"
import script from "./About_Location_Item.vue?vue&type=script&setup=true&lang=js"
export * from "./About_Location_Item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./About_Location_Item.vue?vue&type=style&index=0&id=02fc3c93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fc3c93",
  null
  
)

export default component.exports